<template>
  <div>
    <ContinueFloatingButtonComponent
      class="z-index-1001 mb-5"
      :isScrollToTop="false"
      v-on:continue="catchContinue()"
    >
      <span
        :class="isLarge ? 'btn-continue-large' : 'btn-continue-small'"
      >
        <svg height="80" width="80">
          <text
            x="10"
            y="10"
            style="font-weight: bold"
            :style="isLarge ? ' font-size: 18px' : ''"
          >
            <tspan x="7" y="45">Prosegui</tspan>
          </text>
        </svg>
      </span>
    </ContinueFloatingButtonComponent>
  </div>
</template>

<script>
import ContinueFloatingButtonComponent from "./ContinueFloatingButtonComponent";
import $ from "jquery";

export default {
  props: {
    createItinerary: Boolean,
  },
  components: {
    ContinueFloatingButtonComponent,
  },
  data() {
    return {
      windowWidth: 0,
    };
  },
  methods: {
    catchContinue() {
      this.$emit("continue");
    },
  },

  computed: {
    isLarge() {
      return this.windowWidth >= 768;
    },
  },

  mounted() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });
  },
};
</script>

<style lang="scss" scoped>
.z-index-1001 {
  z-index: 1001;
}

.btn-continue-large {
  border-radius: 50px;
  background-color: #a4ccfc;
  padding-top: 18px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 18px;
}

.btn-continue-small {
  border-radius: 50px;
  background-color: #a4ccfc;
  padding-top: 18px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 18px;
}

</style>
